import HTMLColumnsStrategy from '../HTMLColumnsStrategy'

export default function ProfitLossHTMLPreviewBaseStrategy () {}

ProfitLossHTMLPreviewBaseStrategy.prototype = new HTMLColumnsStrategy();

ProfitLossHTMLPreviewBaseStrategy.prototype.init = function ( timeFormat, showSpentTime )
{
    HTMLColumnsStrategy.prototype.init.call( this, timeFormat );
    this.showSpentTime = showSpentTime;
    return this;
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addFirstHeaderRowCells = function ( firstHeaderRow )
{
    if (this.showSpentTime)
    {
        this.addCell(
                firstHeaderRow,
                this.message( "report.profit_loss.spent.header" ) + " " + this.message( "report.common.unit_work" ),
                "spent",
                1, 2
        );
    }

    this.addCell(
            firstHeaderRow,
            this.getBillableAmountColHeaderText(),
            "billableAmount",
            this.getBillableAmountColSpan(),
            this.getBillableAmountRowSpan()
    );

    this.addCell(
            firstHeaderRow,
            this.getCostOfWorkColHeaderText(),
            "costOfWork",
            this.getCostOfWorkColSpan(),
            this.getCostOfWorkRowSpan()
    );

    this.addCell(
            firstHeaderRow,
            this.message("report.profit_loss.pl.header") + " (" + SystemSettings.currencySign + ")",
            "pL",
            1, 2
    );
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addSecondHeaderRowCells = function ( secondHeaderRow )
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountColHeaderText = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkColHeaderText = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountColSpan = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountRowSpan = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkColSpan = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkRowSpan = function ()
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addDataCells = function ( row )
{
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getDataColumnsCount = function ()
{
    // abstract
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewBaseStrategy.js